import React from "react";
import { Routes, Route } from "react-router-dom";
import Services from "./Services/Services";
import Navbar from "./Navbar/Navbar";
import About from "./About/About";
import Homepage from "./Homepage/Homepage";
import Gallery from "./Gallery/Gallery";
import ContactInfo from "./ContactInfo/ContactInfo";

const App = () => {
  return (
    <>
      <Navbar />
      <Routes>
        <Route path="/" element={<Homepage />} />
        <Route path="/about" element={<About />} />
        <Route path="/services" element={<Services />} />
        <Route path="/gallery" element={<Gallery/>} />
        <Route path="/contactus" element={<ContactInfo/>} />
      </Routes>
    </>
  );
};

export default App;
